export interface PdfIconV2Props {
    color?: string;
}

const PdfIconV2 = ({ color }: PdfIconV2Props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 3V7C13 7.26522 13.1054 7.51957 13.2929 7.70711C13.4804 7.89464 13.7348 8 14 8H18M13 3H6C5.46957 3 4.96086 3.21071 4.58579 3.58579C4.21071 3.96086 4 4.46957 4 5V12M13 3L18 8M18 8V12M4 18H5.5C5.89782 18 6.27936 17.842 6.56066 17.5607C6.84196 17.2794 7 16.8978 7 16.5C7 16.1022 6.84196 15.7206 6.56066 15.4393C6.27936 15.158 5.89782 15 5.5 15H4V21M16 18H18M19 15H16V21M10 15V21H11C11.5304 21 12.0391 20.7893 12.4142 20.4142C12.7893 20.0391 13 19.5304 13 19V17C13 16.4696 12.7893 15.9609 12.4142 15.5858C12.0391 15.2107 11.5304 15 11 15H10Z" stroke={color ? color : "#212529"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default PdfIconV2;